import { action, computed, observable, makeAutoObservable } from 'mobx';
import { CreateMarketFormPropsType } from 'src/domains/sportsbook/trading/view/eventDetails/markets/createMarketModal/CreateMarketForm';
import { ChangeEvent } from 'react';
import { PossibleMarketsType } from 'src/AppState/sdk/staff';

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType extends readonly (infer ElementType)[]
    ? ElementType
    : never;
export class CreateMarketFormState {
    @observable selectedMarket: string | null = null;
    @observable templateValidation: boolean | null = null;
    @observable selectedParams: Record<string, string> = {};

    constructor(readonly props: CreateMarketFormPropsType) {
        makeAutoObservable(this);
    }

    // TODO: refactor for loop
    @computed get requiredParams(): Record<string, string> | null {
        if (this.selectedMarket === null) {
            return null;
        }

        for (const market of this.props.markets) {
            const marketIdentifier = market.id ?? market.name;

            if (marketIdentifier === this.selectedMarket) {
                const parameters: Record<string, string> = {};
                for (const requiredParametersItem in market.requiredParameters) {
                    // TODO: Should be change with new trading task
                    // @ts-expect-error
                    parameters[market.name] = market.requiredParameters[requiredParametersItem];
                }
                return market.requiredParameters ? parameters : null;
            }
        }

        return null;
    }

    @computed get marketTemplateBody(): ArrayElement<PossibleMarketsType> | null {
        if (this.selectedMarket === null) {
            return null;
        }

        const matchedMarket =
            this.props.markets.find((market) => {
                const marketIdentifier = market.id ?? market.name;

                return this.selectedMarket === marketIdentifier;
            }) ?? null;

        if (matchedMarket === null) {
            return null;
        }

        return Object.assign(matchedMarket, { selectedLine: this.selectedParams });
    }

    @action onSelectMarket = (e: ChangeEvent<HTMLSelectElement>): void => {
        this.selectedMarket = e.currentTarget.value;
    };

    @action validForm = (): boolean => {
        this.templateValidation = this.selectedMarket !== null;
        const reqParams =
            this.requiredParams !== null && Object.keys(this.requiredParams).length > 0
                ? Object.keys(this.selectedParams).length > 0
                : true;

        return this.templateValidation === true && reqParams;
    };

    @action onSelectOption = (e: ChangeEvent<HTMLSelectElement>): void => {
        const name = e.currentTarget.name;

        const value = e.currentTarget.value;

        this.selectedParams = { [name]: value };
    };

    @action onAddMarket = async (): Promise<void> => {
        const formIsValid = this.validForm();
        if (formIsValid) {
            const data = { templateId: this.selectedMarket ?? '', params: this.marketTemplateBody };
            this.props.onSubmit(data);
            return;
        }

        console.warn('add new market form is not valid');
    };
}
